<template>
	<div class="load"><span :class="cls">{{font}}</span></div>
</template>
<script>
export default {
	props: {
		cls: String,
		font: String
	}
}
</script>


// WEBPACK FOOTER //
// refresh.vue?19ec4f1f